import Datetime from 'react-datetime'
import moment from 'moment'
import type { InstallationSignatureBlock, InstallationSignaturesState } from '../../types'

interface Props {
  isView: boolean
  signatures: InstallationSignaturesState
  updateSignature: (
    block: keyof InstallationSignaturesState,
    patch: Partial<InstallationSignatureBlock>
  ) => void
}

const LEGAL_NOTE =
  'บันทึกสั่งการ ยืนยันความรับผิดชอบ (กรณีการเงินยังไม่เรียบร้อย) ข้าพเจ้าได้ติดต่อลูกค้า/เจ้าของงานแล้ว และขอสั่งให้เปิดงาน โดยยอมรับผิดชอบต่อความเสียหายที่อาจเกิดขึ้นตามระเบียบบริษัท'

const SignatureBlock: React.FC<{
  title: string
  block: InstallationSignatureBlock
  isView: boolean
  onUpdate: (patch: Partial<InstallationSignatureBlock>) => void
}> = ({ title, block, isView, onUpdate }) => (
  <div className='col-12 col-md-6'>
    <div className='border border-gray-200 rounded p-4 h-100'>
      <div className='fw-bold text-gray-800 mb-4'>{title}</div>
      <label className='form-label fs-7 fw-bold mb-1'>ชื่อ</label>
      <input
        type='text'
        className='form-control form-control-sm mb-3'
        value={block.printedName}
        disabled={isView}
        onChange={e => onUpdate({ printedName: e.target.value })}
      />
      <label className='form-label fs-7 fw-bold mb-1'>วันที่</label>
      <Datetime
        locale='en'
        dateFormat='DD/MM/YYYY'
        timeFormat={false}
        value={block.date ?? undefined}
        onChange={(val: any) => {
          if (moment.isMoment(val) || val instanceof Date) {
            onUpdate({ date: moment(val).toDate() })
          }
        }}
        renderInput={props => (
          <input
            {...props}
            autoComplete='off'
            className='form-control form-control-sm'
            disabled={isView}
          />
        )}
        closeOnClickOutside
      />
    </div>
  </div>
)

const InstallationSignaturesSection: React.FC<Props> = ({
  isView,
  signatures,
  updateSignature,
}) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>ลายเซ็น</div>
        </div>
        <div className='card-body'>
          <div className='row gy-4 mb-6'>
            <SignatureBlock
              title='ผู้แทนขาย'
              block={signatures.salesRep}
              isView={isView}
              onUpdate={patch => updateSignature('salesRep', patch)}
            />
            <SignatureBlock
              title='(อนุมัติ ผอ.ฝ.ขาย)'
              block={signatures.salesDirector}
              isView={isView}
              onUpdate={patch => updateSignature('salesDirector', patch)}
            />
          </div>

          <div className='border border-gray-300 rounded p-4 mb-6 bg-light'>
            <div className='fw-bold text-gray-800 mb-3'>บันทึกสั่งการ</div>
            <p className='text-gray-700 fs-7 mb-0'>{LEGAL_NOTE}</p>
          </div>

          <div className='row gy-4'>
            <SignatureBlock
              title='ผู้สั่งให้เปิดงาน'
              block={signatures.workOrderIssuer}
              isView={isView}
              onUpdate={patch => updateSignature('workOrderIssuer', patch)}
            />
            <SignatureBlock
              title='(ผอ.ฝ. รับทราบ)'
              block={signatures.directorAcknowledged}
              isView={isView}
              onUpdate={patch => updateSignature('directorAcknowledged', patch)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationSignaturesSection
